import { Todo } from 'owa-todo-types';
import { TodoFilterFunction } from '../../schema/TodoFilterFunction';

export function buildIsCompleteFilter(isComplete: boolean): TodoFilterFunction {
    return (todo: Todo) =>
        isComplete === true ? todo.Status === 'Completed' : todo.Status !== 'Completed';
}
